exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".overlay-nav{color:#fff!important;background:#000}@media (max-width:61.9275em){.overlay-nav .container{padding:0 20px}}", ""]);
